export default __webpack_public_path__ + "static/media/mississippi.144e37f4.jpg";